import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/dxb/banner_bg.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Dubai">
                <h1>Custom Software Development Company in Dubai</h1>
              </div>
              <p className="main_para">
                Our custom software development Dubai team offers its versatile
                skillset to create enterprise-level applications using the
                latest tech stack and agile practices.Through our expertise and
                experience developing world-class digital solutions, we help our
                partners and clients pave their way to a future that they have
                envisioned and that helps them translate their vision into
                reality – we assist you in making sense of digital ambitions –
                we build them!
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
